import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, Typography } from "antd";
import { GiRailRoad } from "react-icons/gi";

import { useAuth } from "../../../context/AuthContext";
import TcsmgLogo from "../../../assets/tcsmg/logo-tcs-01.png";
import {
  BrandKicker,
  BrandSide,
  BrandSubtitle,
  BrandTitle,
  FormSide,
  Panel,
  Wrapper,
} from "./style";

const { Title, Paragraph } = Typography;

const LoginComponent = () => {
  const { handleSignIn, loadingSession } = useAuth();

  const onFinish = (values: any) => {
    handleSignIn({ username: values?.username, password: values?.password });
  };

  return (
    <Wrapper>
      <Panel>
        <BrandSide>
          <GiRailRoad size={40} />
          <BrandKicker>TCS</BrandKicker>
          <BrandTitle>Pesagem Ferroviária</BrandTitle>
          <BrandSubtitle>
            Controle completo do carregamento, pesagem e histórico da sua
            operação ferroviária em um único lugar.
          </BrandSubtitle>
        </BrandSide>

        <FormSide>
          <img
            src={TcsmgLogo}
            alt="TCS"
            style={{ height: 40, width: "auto", marginBottom: 32 }}
          />

          <Title level={3} style={{ marginBottom: 4 }}>
            Bem-vindo de volta
          </Title>
          <Paragraph type="secondary" style={{ marginBottom: 32 }}>
            Entre com suas credenciais para acessar o sistema.
          </Paragraph>

          <Form
            layout="vertical"
            size="large"
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            requiredMark={false}
          >
            <Form.Item
              label="Usuário"
              name="username"
              rules={[
                { required: true, message: "Entre com seu nome de usuário!" },
              ]}
            >
              <Input
                prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                placeholder="Nome de usuário"
                autoFocus
              />
            </Form.Item>

            <Form.Item
              label="Senha"
              name="password"
              rules={[{ required: true, message: "Entre com sua senha!" }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
                placeholder="Senha"
              />
            </Form.Item>

            <Form.Item style={{ marginTop: 8, marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSession}
                block
              >
                Entrar
              </Button>
            </Form.Item>
          </Form>
        </FormSide>
      </Panel>
    </Wrapper>
  );
};

export default LoginComponent;
